import { IExtendedSearchTrader } from "src/api/client/extended-search.api.types";
import { ITraderAvatarUser } from "src/components-mui/common/trader-avatar/trader-avatar";
import { IAutoCompleteTrader } from "src/types/common";
import { isDeletedUserStatus } from "src/utils/user-status-util";

export const mapExtendedSearchTraderToAvatarUser = (trader: IExtendedSearchTrader): ITraderAvatarUser => ({
    id: trader.id,
    nickName: trader.nickName,
    firstName: trader.firstName,
    lastName: trader.lastName,
    isDeleted: trader.isDeleted,
    profilePictureUrl: trader.isProfilePictureAvailable ? trader.traderImageUrl : null,
});

export const mapAutoCompleteTraderToAvatarUser = (trader: IAutoCompleteTrader): ITraderAvatarUser => ({
    id: trader.id ?? trader.nickName,
    nickName: trader.nickName,
    firstName: trader.firstName,
    lastName: trader.lastName,
    isDeleted: isDeletedUserStatus(trader.userStatus),
    profilePictureUrl: trader.isProfilePictureAvailable ? trader.imageUrl : null,
});
